import { join, map, isArray } from 'lodash';
import React from 'react';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { getLabel } from 'utils/getLabel';
import { ForceScroller } from 'modules/force-scroller';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberManagementEligibilityHistory as MemberManagementEligibilityHistory } from 'ui/views/widgets/memberManagementEligibilityHistory';
 *
 * // render
 * <MemberManagementEligibilityHistory propName='propValue'/>
 */
const _memberManagementEligibilityHistory = ( props ) => {

    const { items, title } = props;

    return (
        <div className='ui-member-management-eligibility-history'>
            
            {/* title */}
            <div className='ui-member-management-eligibility-history__title'>
                { getLabel( title ) }
            </div>

            {/* history view */ }
            <ForceScroller className='ui-member-management-eligibility-history__items'
                arrowStyle={ 'minimal' } gutter={ 0 }
                wrapperContainerClassName={ 'ui-member-management-eligibility-history__items__wrapper' }>
                { map( items, item => {
                    return(
                        <div key={ item.groupId } className='ui-member-management-eligibility-history__items__item'>
                            {/* icon */}
                            <div className='ui-member-management-eligibility-history__items__item__icons'>

                                { map( [ ...Array( 5 ).keys() ], _item => {
                                    return (
                                        <span key={ _item } className='ui-member-management-eligibility-history__items__item__icons__inline'></span>
                                        );
                                } ) }

                                <div className='ui-member-management-eligibility-history__items__item__icons__icon'></div>

                                { map( [ ...Array( 5 ).keys() ], idx => {
                                    return (
                                        <span key={ idx } className='ui-member-management-eligibility-history__items__item__icons__inline'></span>
                                        );
                                } ) }
                            </div>

                            {/* info */}
                            <div className='ui-member-management-eligibility-history__items__item__info'>
                                <div className='ui-member-management-eligibility-history__items__item__info__date'>{ item.date }</div>
                                <div className='ui-member-management-eligibility-history__items__item__info__groupId'>{ isArray( item.groupId ) ? join( item.groupId, ', ' ): item.groupId }</div>
                            </div>
                        </div>
                    );
                } ) }
            </ForceScroller>
        </div>
    );
};

// set display name
_memberManagementEligibilityHistory.displayName = 'memberManagementEligibilityHistory';

// set default props
_memberManagementEligibilityHistory.defaultProps = {};

// prop types
_memberManagementEligibilityHistory.propTypes = {};


/********************************************** */

const memberManagementEligibilityHistoryPreloader = ( ) => {
    return (
        <div className='ui-member-management-eligibility-history-preloader'>
            <div className='ui-member-management-eligibility-history-preloader__title'>
                <div className='ui-member-management-eligibility-history-preloader__title__value'></div>
            </div>
            <div className='ui-member-management-eligibility-history-preloader__items'>
                { map( [ ...Array( 6 ).keys() ], _item => {

                    return (
                        <div key={ _item } className='ui-member-management-eligibility-history-preloader__items__item'>
                            <div className='ui-member-management-eligibility-history-preloader__items__item__icons'>
                                { map( [ ...Array( 5 ).keys() ], id => {
                                    return ( <span key={ id } className='ui-member-management-eligibility-history-preloader__items__item__icons__inline'></span> );
                                } ) }
                                <div className='ui-member-management-eligibility-history-preloader__items__item__icons__icon'>
                                    <div className='ui-member-management-eligibility-history-preloader__items__item__icons__icon__white'></div>
                                </div>
                                { map( [ ...Array( 5 ).keys() ], idx => {
                                    return ( <span key={ idx } className='ui-member-management-eligibility-history-preloader__items__item__icons__inline'></span> );
                                } ) }
                            </div>
                            <div className='ui-member-management-eligibility-history-preloader__items__item__info'>
                                <div className='ui-member-management-eligibility-history-preloader__items__item__info__date'></div>
                                <div className='ui-member-management-eligibility-history-preloader__items__item__info__groupId'></div>
                            </div>
                        </div>
                    );
                } ) }
            </div>
        </div>
    );
};

// set display name
memberManagementEligibilityHistoryPreloader.displayName = 'memberManagementEligibilityHistoryPreloader';

// set default props
memberManagementEligibilityHistoryPreloader.defaultProps = {};

// prop types
memberManagementEligibilityHistoryPreloader.propTypes = {};

export const memberManagementEligibilityHistory = withNetworkState( memberManagementEligibilityHistoryPreloader, _memberManagementEligibilityHistory );

